import axios from "axios";
import {
  APP_PATH,
  LEAVE_COMPANY,
  LOGIN_PATH,
  REVOKED_DOMAIN_ROUTE,
  SUCCESS_DOMAIN_ROUTE,
  ROOT_PATH,
  NOT_FOUND_ROUTE,
  MAINTENANCE,
  ADMIN_SETTINGS_MAINTENANCE_ROUTE
} from "../constants/routes";
import { REDIRECT_PATH } from "../constants/appConstants";
import { getCookieValue, isAdmin } from "../helpers/general";
import * as routes from "../constants/routes"
import { useUserContext } from "../contexts/userContext";

const useAxiosInstance = () => {

  const axiosApiInstance = axios.create();
  const userContext = useUserContext();

  //set xsrf token
  axiosApiInstance.defaults.headers.common['X-XSRF-TOKEN'] = getCookieValue('XSRF-TOKEN');

  let resp = {}
  const excludedRedirectRoutes = [
    ROOT_PATH,
    APP_PATH,
    LOGIN_PATH,
    REVOKED_DOMAIN_ROUTE,
    LEAVE_COMPANY,
    SUCCESS_DOMAIN_ROUTE,
    NOT_FOUND_ROUTE
  ]
  // const setError = useNotificationUpdateContext()

  axiosApiInstance.interceptors.response.use(
    response => {

      if(routes[window.location.pathname] && response.data.loggedIn !== undefined && !response.data.loggedIn && !excludedRedirectRoutes.includes(window.location.pathname)) {
        return window.location.href = REDIRECT_PATH; // this sends to login page, automatically by BE
      }

      resp = {
        success: true,
        data: response.data
      }
      return resp;
    },
    error => {
      resp = {
        success: false,
        message: error.message,
        errorMessages: error?.response?.data?.messageData?.errorMessages,
        errors: error?.response?.data?.errors
      }
      if (error?.response?.status) {
        switch (error.response.status) {
          case 400:
            resp.errors = error.response?.data?.errors;
            break;
          case 401:
            window.location.href = REDIRECT_PATH
            break;
          // validations error
          case 422:
            //...
            break;
          //maintenance page
          case 503:
            if(!isAdmin(userContext)) {
              window.location.href = MAINTENANCE
            } else {
              window.location.href = ADMIN_SETTINGS_MAINTENANCE_ROUTE
            }
            break;
          default:
            // setError([
            //   error.message
            // ]);
            break;
        }
      }

      return resp;
    });
  return axiosApiInstance
}

export default useAxiosInstance